export const SOCIAL_CARD_FRESHNESS_PARAM = "xcard";
export const SOCIAL_CARD_FRESHNESS_BUCKET_MS = 10 * 60 * 1000;

const freshnessPattern = /^(\d{4})(\d{2})(\d{2})T(\d{2})([0-5]0)Z$/;

export function buildSocialCardFreshnessValue(now = new Date()) {
  const date = now instanceof Date ? now : new Date(now);
  const time = date.getTime();
  if (!Number.isFinite(time)) return "";

  const bucketDate = new Date(Math.floor(time / SOCIAL_CARD_FRESHNESS_BUCKET_MS) * SOCIAL_CARD_FRESHNESS_BUCKET_MS);
  return [
    bucketDate.getUTCFullYear(),
    pad2(bucketDate.getUTCMonth() + 1),
    pad2(bucketDate.getUTCDate()),
    "T",
    pad2(bucketDate.getUTCHours()),
    pad2(bucketDate.getUTCMinutes()),
    "Z"
  ].join("");
}

export function normalizeSocialCardFreshnessValue(value) {
  const raw = String(value || "").trim();
  const match = raw.match(freshnessPattern);
  if (!match) return "";

  const [, year, month, day, hour, minute] = match;
  const date = new Date(Date.UTC(Number(year), Number(month) - 1, Number(day), Number(hour), Number(minute)));
  if (
    date.getUTCFullYear() !== Number(year) ||
    date.getUTCMonth() + 1 !== Number(month) ||
    date.getUTCDate() !== Number(day) ||
    date.getUTCHours() !== Number(hour) ||
    date.getUTCMinutes() !== Number(minute)
  ) {
    return "";
  }

  return raw;
}

export function appendSocialCardFreshness(url, value) {
  const targetUrl = url instanceof URL ? new URL(url.href) : new URL(String(url));
  const freshness = normalizeSocialCardFreshnessValue(value);
  if (freshness) {
    targetUrl.searchParams.set(SOCIAL_CARD_FRESHNESS_PARAM, freshness);
  }
  return targetUrl;
}

function pad2(value) {
  return String(value).padStart(2, "0");
}
